import React from "react";
import { parseISO } from "date-fns";
import { ArAgingSummaryResponse } from "@common/types/reports/types";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { Card } from "@design-system/Card/Card";
import { CardSection } from "@design-system/Card/CardSection";
import { AccountingReportFilters } from "../types";
import {
    AccountingReportContext,
    useAccountingReportContextValue,
} from "../AccountingReport.context";
import { AccountingReportHeader } from "../AccountingReportHeader";
import { AccountingReportFooter } from "../AccountingReportFooter";
import { useReportChrome } from "../useReportChrome";
import { ArAgingDetailDrillDownParams } from "./arAgingDetailDrillDown.lib";
import { ArAgingSummaryTable } from "./ArAgingSummaryTable";
import styles from "./ArAgingSummaryTable.module.scss";

interface Props {
    data: ArAgingSummaryResponse;
    filters: AccountingReportFilters;
    chrome: ReportPresentationChrome;
    numberFormat: NumberFormatValues;
    generationDate: Date;
    onDrillDown: (params: ArAgingDetailDrillDownParams) => void;
}

export const ArAgingSummaryContent: React.FC<Props> = ({
    data,
    filters,
    chrome,
    numberFormat,
    generationDate,
    onDrillDown,
}) => {
    const resolvedChrome = useReportChrome({ chrome, generationDate });
    const accountingReportContextValue = useAccountingReportContextValue(
        {
            ...filters,
            asOfDate: parseISO(data.asOfDate),
        },
        numberFormat,
    );

    return (
        <Card stacked sharpEdges fullPage>
            <AccountingReportContext.Provider
                value={accountingReportContextValue}
            >
                <CardSection className={styles.header}>
                    <AccountingReportHeader chrome={resolvedChrome} />
                </CardSection>
                <ArAgingSummaryTable data={data} onDrillDown={onDrillDown} />
                <AccountingReportFooter chrome={resolvedChrome} />
            </AccountingReportContext.Provider>
        </Card>
    );
};
